import React, { useState, useEffect } from 'react';
import {
    Card,
    Checkbox,
    FormControlLabel,
    Grid,
    Button,
    CircularProgress,
    Dialog
} from '@material-ui/core'
import { TextValidator } from 'react-material-ui-form-validator'
import { SubTitle, ValidatorForm } from 'app/components/LoonsLabComponents'
import { Autocomplete } from '@material-ui/lab'
import { Alert } from '@material-ui/lab'
import { IconButton, InputAdornment } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { makeStyles } from '@material-ui/core/styles'
import history from 'history.js'
import clsx from 'clsx'
import useAuth from 'app/hooks/useAuth'
import localStorageService from 'app/services/localStorageService'
import * as appConst from '../../../../appconst'
import EmployeeServices from 'app/services/EmployeeServices'
import ClinicService from 'app/services/ClinicService'
import { uniqBy } from 'lodash'
import Zoom from '@material-ui/core/Zoom';
import Slide from '@material-ui/core/Slide';
import { getEnv } from 'envConfig'

import { Typography, Box, AppBar, Toolbar } from "@mui/material";

const useStyles = makeStyles(({ palette, breakpoints, ...theme }) => ({

    cardHolder_default: {
        // background: '#1A2038',
        //background: '#a3d0a9',
        paddingLeft: 250,
        paddingRight: 250,

        //background: 'linear-gradient(13deg, #ace0c1, #aedce7);',
        //background: 'linear-gradient(13deg, #ffffff, #e4e4e4)',
        background: 'linear-gradient(142deg, #ffffff, #e2f7ff)',
        //backgroundImage: 'url(/assets/images/loginpage/background.webp)',
        backgroundSize: 'cover',
        backgroundPosition: '50%',
        [breakpoints.down('sm')]: {
            paddingLeft: 20,
            paddingRight: 20,
        },
        // Fade-in animation
    },
    rightSection: {
        //background: 'linear-gradient(13deg, #ace0c1, #aedce7);',
        backgroundImage: 'url(/assets/images/loginpage/booking.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: '90%',
    },

    buttonProgress: {

        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    bottomRight: {
        position: 'fixed',
        bottom: '10px',
        right: ' 10px',
        color: '#848484'
    }
}))

const LoonsLogin = () => {
    const [swasthaLoginPage, setSwasthaLoginPage] = useState(getEnv().SWASTHSA_COMMON_LOGIN_VIEW)
    const [loading, setLoading] = useState(false)
    const [userInfo, setUserInfo] = useState({
        email: '',
        password: '',
        totp: ''
    })
    const [message, setMessage] = useState('')
    const [selectUserRole, setSelectUserRole] = useState(false)
    const [advanceSearchTemp, setAdvanceSearchTemp] = useState()
    const [userInfoRes, setUserInfoRes] = useState(null)
    const [otherUserRole, setOtherUserRole] = useState([])
    const [AllEmployeeInstitutions, setAllEmployeeInstitutions] = useState([])
    const [selectingInstititute, setSelectingInstititute] = useState(false)


    const [selectedInstitiute, setSelectedInstitiute] = useState(null)
    const [user, setUSer] = useState(null)
    const [showPassword, setShowPassword] = useState(false);

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const { login } = useAuth()

    const classes = useStyles()

    const handleChange = ({ target: { name, value } }) => {
        let temp = { ...userInfo }
        temp[name] = value
        setUserInfo(temp)
    }

    /*  useEffect(async () => {
         let envData = await getEnv()
         console.log("env data", envData)
         if (getEnv().SWASTHSA_COMMON_LOGIN_VIEW) {
             setSwasthaLoginPage(true)
         } else {
             setSwasthaLoginPage(false)
         }
     }, []) */






    // const handleFormSubmit = async (event) => {
    //     const afterAdvanceSearch = await localStorageService.getItem("advanceSearch");
    //     console.log("afterAdvanceSearch", afterAdvanceSearch)
    //     setAdvanceSearchTemp(afterAdvanceSearch)
    //     setLoading(true)
    //     try {
    //         let res = await login(userInfo.email, userInfo.password, userInfo.totp)
    //         console.log("ress", res)

    //         if (res.error) {
    //             setMessage(res.message)
    //             setLoading(false)
    //         } else {
    //             let res_temp = res

    //             console.log("changed advanceSearchTemp-3", advanceSearchTemp)
    //             console.log("changed user roles", res_temp)
    //             setUSer(res_temp)
    //             setUserInfoRes(res)
    //             saveUserRole(res)

    //         }

    //         //history.push('/')
    //     } catch (e) {
    //         console.log('error', e)
    //         setMessage(e.error_description)
    //         setLoading(false)
    //     }
    // }

    const handleFormSubmit = async (event) => {
        if (event && typeof event.preventDefault === 'function') {
            event.preventDefault();
        }

        const advanceSearch = await localStorageService.getItem("advanceSearch");

        setLoading(true);
        try {
            let res = await login(userInfo.email, userInfo.password, userInfo.totp);
            if (res.error) {
                setMessage(res.message);
                setLoading(false);
            } else {
                saveUserRole(res, advanceSearch);
            }
        } catch (e) {
            setMessage(e.error_description);
            setLoading(false);
        }
    };



    // const saveUserRole = async (res) => {
       
    //     //let user_roles = [selectedUserRoleNew, 'uma_authorization', 'offline_access', 'default-roles-swastharealm']
        
    //     let user_roles = res.roles

    //     user_roles.splice(user_roles.indexOf('default-roles-lyfetraveller'), 1)
    //     user_roles.splice(user_roles.indexOf('offline_access'), 1)
    //     user_roles.splice(user_roles.indexOf('uma_authorization'), 1)

    //     let user_info_res = res;
    //     user_info_res.roles = user_roles;

    //     console.log("changed user roles login", user_roles)

    //     if (user_info_res) {

    //         await localStorageService.setItem("userInfo", user_info_res)
    //     }

        

    //     if (user_roles[0] == 'Customer') {
    //         history.push('/home')
    //     } else {
    //        history.push('/') 
    //     }
       

    // }

    const saveUserRole = async (res, advanceSearch) => {
        // Filter out unwanted roles
        let user_roles = res.roles.filter(role =>
            !['default-roles-lyfetraveller', 'offline_access', 'uma_authorization'].includes(role)
        );

        let user_info_res = { ...res, roles: user_roles };

        if (user_info_res) {
            await localStorageService.setItem("userInfo", user_info_res);
            window.dispatchEvent(new Event("userInfoUpdated"));
            
            if (advanceSearch) {
                await localStorageService.setItem("advanceSearch", advanceSearch);
            }

            localStorage.setItem("userLoggedIn", "true");

            console.log("User roles after login:", user_roles);

            // ✅ Role-based redirect logic
            let redirectPath = '/'; // default
            const primaryRole = user_roles[0];

            if (primaryRole === 'Customer') {
                redirectPath = '/home';
            } else if (primaryRole === 'Super Admin' || primaryRole === 'Hotel Owner') {
                redirectPath = '/';
            } else {
                redirectPath = '/dashboard'; // optional default route
            }

            // Delay to ensure data is saved first
            setTimeout(() => {
                window.close();
                if (!window.closed) {
                    history.push(redirectPath);
                }
            }, 300);
        }
    };










    return (
            <div
                className="flex justify-center items-center min-h-screen"
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundImage: "url('/assets/images/loginBackgraounds/beautiful-girl-doing-yoga1.png')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    padding: "8px",
                    minHeight: "100vh", // Ensures full height
                    flexDirection: "column", // Keeps content stacked vertically
                }}
            >
                {/* Fix: AppBar should not push content down */}
                <AppBar position="absolute" color="transparent" elevation={0} sx={{ top: 0, width: "100%" }}>
                    <Toolbar>
                        <Typography variant="h6" sx={{ flexGrow: 1, textAlign: "center", color: "white", fontSize:'36px' }}>
                            Lyfe Traveller
                        </Typography>
                    </Toolbar>
                </AppBar>
    
                {/* Fix: Added paddingTop to prevent overlap */}
                <Card 
                    style={{
                        backgroundColor: "#FFFFFFD4", 
                        borderRadius: 15, 
                        maxWidth: "588px", 
                        width: "100%", 
                        paddingTop: "10px", // Adjust for AppBar height
                    }}
                >
                    <Grid container>
    
                        {/* <Slide direction="right" in={true} mountOnEnter unmountOnExit>
                            <Grid className={clsx('hide-on-mobile', classes.rightSection)} item lg={7} md={7} sm={12} xs={12} style={{ height: '60vh' }}>
    
                            </Grid>
                        </Slide> */}
                        <Grid item xs={12}>
    
    
                            <div className="p-8 h-full flex items-center justify-center">
                                <div className="text-center w-full" style={{ maxWidth: "452px", width: "100%" }}>
                                    <Typography className='mb-5' variant="h5" gutterBottom color="textSecondary" fontWeight="bold">
                                        Log In
                                    </Typography>
                                {!selectUserRole &&
                                    <Slide direction="up" in={true} mountOnEnter unmountOnExit>
                                        <ValidatorForm onSubmit={handleFormSubmit}>
                                            <Typography variant="subtitle1" sx={{ lineHeight: 1, textAlign: "left" }}>
                                                Username
                                            </Typography>
                                            <TextValidator
                                                className="w-full"
                                                variant="outlined"
                                                size="medium"
                                                placeholder="Username"
                                                onChange={handleChange}
                                                type="text"
                                                name="email"
                                                value={userInfo.email}
                                                validators={['required']}
                                                errorMessages={[
                                                    'This field is required',
    
                                                ]}
                                            />
    
                                            <Typography className='mt-3' variant="subtitle1" sx={{ lineHeight: 1, textAlign: "left" }}>
                                                Password
                                            </Typography>
                                            <TextValidator
                                                className="w-full mb-3"
                                                placeholder="Password"
                                                variant="outlined"
                                                size="medium"
                                                onChange={handleChange}
                                                name="password"
                                                type={showPassword ? 'text' : 'password'}
                                                value={userInfo.password}
                                                validators={['required']}
                                                errorMessages={['This field is required']}
                                                //helperText="Enter your password here"
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                aria-label="toggle password visibility"
                                                                onClick={handleClickShowPassword}
                                                                onMouseDown={handleMouseDownPassword}
                                                                size='small'
                                                            >
                                                                {showPassword ? <VisibilityOff className='mt--1' /> : <Visibility className='mt--1' />}
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
    
    
                                            {message && (
                                                <p className="text-error">{message}</p>
                                            )}
    
    
                                            <div >
                                                <div >
                                                    {/* <Button
                                                        variant="contained"
                                                        color="primary"
                                                        disabled={loading}
                                                        type="submit"
                                                    >
                                                        Sign in
                                                    </Button> */}
                                                    <Button 
                                                        fullWidth 
                                                        disabled={loading}
                                                        className="rounded mt-3" 
                                                        variant="contained" 
                                                        style={{ backgroundColor: "#24AB70" }}
                                                        type="submit"
                                                    >
                                                        Sign in
                                                    </Button>
                                                    {loading && (
                                                        <CircularProgress
                                                            size={24}
                                                            className={
                                                                classes.buttonProgress
                                                            }
                                                        />
                                                    )}
                                                </div>
                                                {/*  <span className="mr-2 ml-5">or</span>
                                        <Button
                                            className="capitalize"
                                            onClick={() =>
                                                history.push('/session/signup')
                                            }
                                        >
                                            Sign up
                                        </Button> */}
                                            </div>
                                            {/* <Typography className="mt-3" variant="body2" color="textSecondary">
                                                - OR -
                                            </Typography>
        
                                            <Button 
                                                className="rounded capitalize mt-3" 
                                                fullWidth 
                                                variant="outlined"
                                                sx={{ mt: 2, gap: 1 }}
                                            >
                                                <img
                                                    src='/assets/icons/google-logo.png'
                                                    alt="Google logo"
                                                    width={20}
                                                    height={20}
                                                    className='mr-3'
                                                />
                                                Continue with Google
                                            </Button> */}
    
                                            <Button
                                                className="text-primary mt-3"
                                                onClick={() =>
                                                    history.push('/session/forgot-password')
                                                }
                                            >
                                                Forgot password?
                                            </Button>

                                            <Button 
                                                className="rounded capitalize mt-3" 
                                                fullWidth 
                                                variant="outlined"
                                                sx={{ mt: 2, gap: 1 }}
                                                onClick={() =>
                                                    history.push('/session/signup')
                                                }
                                            >
                                                Sign Up
                                            </Button>
    
    
    
                                        </ValidatorForm>
    
                                    </Slide>
                                }
                                </div>
                            </div>
    
                        </Grid>
                    </Grid>
                </Card>

                
    
    
                {/* <div className={classes.bottomRight}>
                    V {appConst.version}
                </div> */}
            </div>
        )
}

export default LoonsLogin
